<template>
  <div>
    <div class="remington-typed-font full-height text-align-center">
      <div class="inline-block margin-auto width-90 full-height vertical-middle">
        <nav class="navigationList inline-block">
          <ul>
            <li class="navbar-tabs"><router-link :to="{name: 'AboutUS'}">General</router-link></li>
            <li class="navbar-tabs"><router-link :to="{name: 'StructureMain'}">Structure</router-link></li>
            <li class="navbar-tabs"><router-link :to="{name: 'CampaignsMain'}">Campaigns</router-link></li><!--              <li>|</li>-->
            <li class="navbar-tabs"><router-link :to="{name: 'ProceduresMain'}">Procedures</router-link></li>
            <li class="navbar-tabs"><router-link :to="{name: 'RulesMain'}">Rules</router-link></li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="typed-on-paper-a4">
      <h1 class="text-align-center">
        Ranks
      </h1>
      <p class="text-align-justify">
        In FTC, ranks exist mainly to provide the necessary historical flavour to our experience.
        No one is of course obliged to call anyone else 'Sir', nor does rank imply that a certain respect must be shown towards the person in question.
        We are all the same in FTC, we are here to enjoy flying planes in an authentic and persistent multiplayer environment. Nothing more, nothing less.
        </p>
      <p>
        From an administrative standpoint, ranks exist to provide people with a structure in each unit.
      </p>
      <p>
        New members start at the respective lowest grades for each faction. Historically however, whereas in the Luftwaffe pilots would regularly be Gefreitern (the lowest rank in the Luftwaffe), the ranks below Sergeant in the RAF were not flying ranks, i.e. these ranks were reserved for the group crews.
        This means that members joining the RAF will be given the rank of Sergeant. If a unit switches faction, or a member changes unit, then the rank is adjusted accordingly.
      </p>
      <p>
        On the whole, ranks exist only as part of the historical experience we try to emulate, as well as to show off and reward members for their help, ability, dedication or responsibility in the group.
      </p>
      <div>
        <table class="width-100 margin-auto">
          <tr>
            <th class="width-20">{{factionStatus[1].long}}</th>
            <th class="width-20">{{factionStatus[2].long}}</th>
            <th class="width-20">{{factionStatus[3].long}}</th>
            <th class="width-20">{{factionStatus[4].long}}</th>
            <th class="width-20">{{factionStatus[5].long}}</th>
          </tr>

          <tr>
            <td>
              <UniformRankComp
                class=""
                v-bind:single_component="true"
                v-bind:rank_real_value="rank_value"
                v-bind:rank_lookup ="ranks"
                v-bind:faction="1"
                v-bind:show_portrait="false"
              ></UniformRankComp>
            </td>
            <td>
              <UniformRankComp
                class=""
                v-bind:single_component="true"
                v-bind:rank_real_value="rank_value"
                v-bind:rank_lookup ="ranks"
                v-bind:faction="2"
                v-bind:show_portrait="false"
              ></UniformRankComp>
            </td>
            <td>
              <UniformRankComp
                class=""
                v-bind:single_component="true"
                v-bind:rank_real_value="rank_value"
                v-bind:rank_lookup ="ranks"
                v-bind:faction="3"
                v-bind:show_portrait="false"
              ></UniformRankComp>
            </td>
            <td>
              <UniformRankComp
                class=""
                v-bind:single_component="true"
                v-bind:rank_real_value="rank_value"
                v-bind:rank_lookup ="ranks"
                v-bind:faction="4"
                v-bind:show_portrait="false"
              ></UniformRankComp>
            </td>
            <td>
              <UniformRankComp
                class=""
                v-bind:single_component="true"
                v-bind:rank_real_value="rank_value"
                v-bind:rank_lookup ="ranks"
                v-bind:faction="5"
                v-bind:show_portrait="false"
              ></UniformRankComp>
            </td>
            <td>
              <UniformRankComp
                class=""
                v-bind:single_component="true"
                v-bind:rank_real_value="rank_value"
                v-bind:rank_lookup ="ranks"
                v-bind:faction="6"
                v-bind:show_portrait="false"
              ></UniformRankComp>
            </td>
			<td>
              <UniformRankComp
                class=""
                v-bind:single_component="true"
                v-bind:rank_real_value="rank_value"
                v-bind:rank_lookup ="ranks"
                v-bind:faction="7"
                v-bind:show_portrait="false"
              ></UniformRankComp>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
import statConv from "../../resource/statusConverter"
import UniformRankComp from "../member/UniformRankComp"

export default {
  name: "Ranks",
  components: {
    UniformRankComp
  },
  mixins: [
    statConv
  ],
  mounted () {

    this.$dbCon.requestViewData(this.$options.name,
      {view: "rank_lookup"})
      .then(response => {
        this.ranks = response;
      })
      .catch(error => {
        console.log(error.message);
      });
  },
  data () {
    return {

      ranks: [],
    }
  },
  computed: {

    rank_values: function () {

      return [...new Set(this.ranks.map(item => item.real_value))];
    }

  },
  methods: {

    rank_data: function (real_value, faction) {

      return this.ranks.find(
        function (item) {
          return (item.faction == faction) && (item.disp_value == real_value);
        }
      )
    }
  }
}
</script>

<style scoped>

ul {
  margin-left: 0px;
  list-style-type: circle;
}

table {
  border-collapse: separate;
  border-spacing: 0px 5px;
}

td, th {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 15px;
}

.navbar-tabs {
  min-height: 0px;
  width: calc(100% - 0px); /* Whished widht in % minus 2x border size */
  padding: 20px;
  padding-bottom: 15px;
  font-family: "Remingtoned Type";
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-image: url("/frontend/src/assets/images/ftcpaper.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  box-shadow: 0px -5px 15px rgba(10,10,10,0.3);
  color: #1b1b1b;
}

.navigationList li {
  display: table-cell;
  font-size: 125%;
  text-align: center;
}

.navigationList li a {
  padding: 0px 40px;
  text-decoration: none;
  font-weight: bold;
  color: #1b1b1b;
}

.navigationList li a:hover{
  color: #1b1b1b;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  /*border-top-left-radius: 15px;*/
  /*border-top-right-radius: 15px;*/
  border-radius: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/info/Ranks.vue